/**
 * Flat configuration for feature module locking.
 * Use the module's unique ID from the backend to enable/disable specific features.
 */
export const MODULES = {
  // Employee Module
  EMPLOYEE: "default",
  // EMPLOYEE_DASHBOARD: 'default',
  EMPLOYEE_DASHBOARD: "12c687cd-7e9e-46ce-bc8e-05b7b53af590", //Dynamic Admin Panel ID
  ADMIN_MANAGEMENT_DASHBOARD: "12c687cd-7e9e-46ce-bc8e-05b7b53af591",
  EMPLOYEE_ATTENDANCE: "41771cc3-aacc-45e0-a811-948a5881434e",
  EMPLOYEE_LEAVE: "accebcef-7375-4f88-a51c-a498658bf5d8",
  EMPLOYEE_SHIFT_MANAGEMENT: "9e77e793-85e1-47e2-972d-4ff4e3496bee",
  EMPLOYEE_PAYROLL: "dfd5b88d-aed3-47a4-84be-a910e2d71c50",
  EMPLOYEE_SYSTEM_ANALYTICS: "",
  EMPLOYEE_ONBOARD_MANAGEMENT: "",
  // Feature Dependencies (Granular Features)
  EMPLOYEE_POLICIES: "12c687cd-7e9e-46ce-bc8e-05b7b53af596",
  EMPLOYEE_PERFORMANCE: "24591660-6b10-453a-a648-833494c46326",
  EMPLOYEE_REPORTS: "default",

  // Recruitment Module
  RECRUITMENT: "02cf5424-6aea-45b7-a2f1-878c8e8baeb1",

  // Control Panel
  CONTROL_PANEL: "default",
  CONTROL_PANEL_ACTIVITY: "default",
  CONTROL_PANEL_DASHBOARD: "12c687cd-7e9e-46ce-bc8e-05b7b53af590", //Dynamic Admin Panel ID
  CONTROL_PANEL_ROLE_PERMISSION: "12c687cd-7e9e-46ce-bc8e-05b7b53af594",
  CONTROL_PANEL_ORGANIZATION: "dd75e237-4607-4db4-bebe-98ef20343163",
  CONTROL_PANEL_POLICIES: "12c687cd-7e9e-46ce-bc8e-05b7b53af596",

  // Performance
  PERFORMANCE: "24591660-6b10-453a-a648-833494c46326",
  PERFORMANCE_KPI: "24591660-6b10-453a-a648-833494c46326",
  PERFORMANCE_APPRAISAL: "24591660-6b10-453a-a648-833494c46326",
  PERFORMANCE_USER_GUIDELINE: "24591660-6b10-453a-a648-833494c46326",
} as const;

export default MODULES;
